export default __webpack_public_path__ + "static/media/flower-interstitial-bg.b16dfd84.png";